import { isCatSegmentation, SegmentationIds } from 'constants/segmentation';
import { PetContextValues } from 'contexts/pet';
import { SegmentationStore } from 'contexts/segmentation';
import convertSegmentationToArray from '../convert-segmentation-to-array';

/**
 * Check if segmentation id matches with current pet type
 */
export const checkSegmentationMatch = ({
  currentPetType,
  segmentation,
  keysToOmit = ['allergySegmentation'],
}: {
  currentPetType: PetContextValues;
  segmentation: SegmentationIds | SegmentationStore;
  keysToOmit?: (keyof SegmentationStore)[];
}): boolean => {
  if (typeof segmentation === 'object') {
    return convertSegmentationToArray({
      store: segmentation,
      keysToOmit,
    }).some((v) => checkMatch({ segmentationId: v, currentPetType }));
  }
  return checkMatch({
    segmentationId: segmentation,
    currentPetType,
  });
};

const checkMatch = ({
  currentPetType,
  segmentationId,
}: {
  currentPetType: PetContextValues;
  segmentationId: SegmentationIds;
}): boolean => {
  if (!currentPetType) {
    return false;
  }

  if (isCatSegmentation(segmentationId)) {
    return currentPetType === 'cats';
  } else {
    return currentPetType === 'dogs';
  }
};
